import { createFileRoute } from "@tanstack/react-router"
import LeadAnalyticsPage from "@/components/coreAnalytics/leads/LeadAnalyticsPage"

export const Route = createFileRoute("/core/lead-docket/analytics")({
  component: LeadAnalyticsPage
})
